<template>
    <div class="customer-profile registration-customer-form">
        <div class="content-area">
            <base-header
                :menu-listing="getMenuListing"
                step-style
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <!--<base-header v-if="configData.documentUpload==true":menu-listing="menuListing"  step-style @sidemenu="$emit('responsiveSideBar')"></base-header>-->
            <div class="right-panel">
                <div class="wrap-content customer-section">
                    <div class="filter-section">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>{{ $route.meta.name }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <router-view></router-view>
                        <b-modal
                            ref="modalError"
                            size="md"
                            title="Welcome to Idenfo Direct"
                            hide-footer
                            hide-header-close
                            :click-to-close="false"
                            :no-close-on-backdrop="true"
                            :no-close-on-esc="true"
                        >
                            <div class="modal-body-disclaimer">
                                <p class="paragraph">
                                    Hi
                                    <span style="text-transform: capitalize">{{
                                        user.firstName
                                    }}</span
                                    >! <br /><br />
                                    <!--It looks like you've hit the limit on the number of profiles-->
                                    <!--included in your current pricing plan :( To continue to-->
                                    <!--onboard another profile, you will have to purchase the next-->
                                    <!--package. Would you like to upgrade now?-->
                                    To begin onboarding and verifying profiles
                                    with your Idenfo Direct account, please
                                    subscribe to one of our flexible pricing
                                    packages.
                                </p>
                                <div class="row justify-content-center">
                                    <div
                                        v-if="country !== 'Pakistan'"
                                        class="m-2"
                                    >
                                        <b-button
                                            variant="primary"
                                            @click="payments"
                                            >Plans</b-button
                                        >
                                    </div>
                                    <div class="m-2">
                                        <b-button
                                            variant="secondary"
                                            @click="currentPlan"
                                            >Cancel</b-button
                                        >
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
import resource from '@/api/resource'
const modulesApi = new resource('configurations/modules')

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'idenfoId',
                sortOrder: 'desc',
            },
            resourceApi: null,
            deepLinkRegisteredCount: 0,
            selfRegisteredCount: 0,
            configData: {
                dataSegmentId: null,
                riskFactor: null,
                liveness: null,
                nameScreening: null,
                documentUpload: null,
                companyType: null,
                counter: null,
                subscription: null,
                tier: null,
                accountinfo:null,
                restrictDuplicateCustomers: null,
            },
            country: process.env.VUE_APP_COUNTRY,
            menuListing: [
                {
                    // anchorLink: '/register-customer/upload-document',
                    menuLabel: 'Upload Documents',
                    sessionStep: '1',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },

                {
                    // anchorLink: '/register-customer/setup-profile',
                    menuLabel: 'Setup Profile',
                    sessionStep: '3',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/account-info',
                    menuLabel: 'Account Info',
                    sessionStep: '4',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/account-info',
                    menuLabel: 'Preview',
                    sessionStep: '5',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/finish',
                    menuLabel: 'Finish',
                    sessionStep: '6',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
            ],
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['form', 'dataSegmentId', 'user','dataSegmentConfigurations']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        getMenuListing() {
            let arr = this.menuListing
            for (var key in arr) {
                if (
                    this.configData.documentUpload == false &&
                    arr[key].sessionStep == 1
                ) {
                    arr.splice(key, 1)
                }
                if (
                    this.configData.nameScreening == false &&
                    arr[key].sessionStep == 3
                ) {
                    arr.splice(key, 1)
                }
                // if (this.configData.riskFactor == false && arr[key].sessionStep == 4) {
                //     arr.splice(key, 1)
                // }
                // if (this.configData.companyType == 'non-financial' && arr[key].sessionStep == 4) {
                //     arr.splice(key, 1)
                // }
                if (this.configData.accountinfo ==false && arr[key].sessionStep == 4) {
                    arr.splice(key, 1)
                }
            }
            return arr
        },
        // getMenuListing() {
        //
        //     if (this.configData.documentUpload == false) {
        //         this.menuListing.splice(0,1)
        //     }
        //     return this.menuListing
        // },
    }, // End of Component > mounted

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
    watch: {
        dataSegmentId(value) {
            if (value) {
                // this.goToFirstStep()
                this.checkOcrSwitch()
                this.getConfigData()
            }
        },
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    async mounted() {
        if (!this.user.kyb) {
            this.$router.push({
                name: '/404',
            })
        }
        await this.getConfigData()
        // this.goToFirstStep()
        this.checkOcrSwitch()
        this.$store.commit('initDefaultFields', 'form')
        let customerType = 'individual'
        if (this.$route.path.includes('company')) {
            customerType = 'company'
        }
        this.$store.commit('updateField', {
            key: 'type',
            value: customerType,
        })
        await this.getCounter()
        await this.updateIdentityInfo()
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * go to the first step
         *
         * @return {void}
         */
        goToFirstStep() {
            if (
                ![
                    //'setup-profile',
                    'self-registration-company-upload-document',
                ].includes(this.$route.name)
            ) {
                // if (this.$route.meta.publicRegistration === true)
                {
                    if (this.configData.documentUpload == true) {
                        this.$router.push({
                            name: 'self-registration-company-upload-document',
                            params: {
                                dataSegmentId: this.dataSegmentId,
                            },
                        })
                    } else {
                        this.$router.push({
                            name: 'self-registration-company-setup-profile',
                            params: {
                                dataSegmentId: this.dataSegmentId,
                            },
                        })
                    }
                }
                // else {
                //     this.$router.push({
                //         name: 'setup-profile',
                //     })
                // }
            }
        }, // End of goToFirstStep() method

        /**
         * check if the ocr switch configurations
         * is on for this data segment
         *
         * @return {void}
         */
        async checkOcrSwitch() {
            try {
                let { data } = await request({
                    url: `/configurations/ocr/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })

                this.$store.commit('setValue', {
                    key: 'useOcr',
                    value: data.data.switch,
                })

                this.$store.commit('setValue', {
                    key: 'restrictDuplicateCustomers',
                    value: data.data.restrictDuplicateCustomers,
                })
            } catch (error) {
                // console.log(error)
            }
        }, // End of checkOcrSwitch() method
        async getConfigData() {
            try {
                if (this.dataSegmentId) {
                    // let { data } = await modulesApi.list({
                    //     dataSegmentId: this.dataSegmentId,
                    // })
                  if (!_.isEmpty(this.dataSegmentConfigurations)) {
                        this.configData = this.dataSegmentConfigurations
                        this.$store.state.registration.configData = this.configData
                    }
                    this.showPageLoader = false
                }
            } catch (error) {
                this.showPageLoader = false
            }
        },
        async getCounter() {
            if (this.configData.subscription == 'unpaid') {
                this.configData.counter = 0
            }

            this.$store.commit('showPageLoader', true)
            try {
                this.resourceApi = new resource('users/count-applications')
                let params = {
                    dataSegmentId: this.dataSegmentId,
                }
                let { data } = await this.resourceApi.list(params)
                if (data && data.tierAttains) {
                    this.$refs.modalError.show()
                }
                // False the page loader after the list has been loaded
                this.$store.commit('showPageLoader', false)
                this.$store.commit('setLoading', false)
            } catch (error) {
                this.$store.commit('showPageLoader', false)
                this.$store.commit('setLoading', false)
                // this.$store.commit('setError', error)
            }
        },

        payments() {
            this.$refs.modalError.hide()
            this.$router.push('/billing')
        },
        currentPlan() {
            this.$refs.modalError.hide()
            this.$router.push('/customer-profiles')
        },
        async updateIdentityInfo() {
            if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: 'id',
                })
            } else {
                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: 'passport',
                })
            }
        },
    }, // End of Component > watch
} // End of export default
</script>
